import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Pagination, Skeleton, TextField } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import Page from '../../component/Page'
import dayjs from 'dayjs'
import StockContext from './services/stockApi'
import { useSelector } from 'react-redux'
import { STOCK_CONFIG } from './config'
import api from '../../api/api'
import { getData } from '../../services/api'
import './stockTransfer.scss'
export default function StockTransfer() {
    const [data, setData] = useState([])
    // const { getTransferList } = useContext(StockContext);
    const [searchParams, setSearchParams] = useSearchParams()
    const { profile } = useSelector(state => state.profile)
    let q = searchParams.get('q') || ''
    let id = searchParams.get('id') || ''
    let page = searchParams.get('page') || '1'

    const [loading, setLoading] = useState(false);
    const [rowsPerPage] = useState(10);

    const getTransferList = async () => {
        setLoading(true)
        let _params = '';
        let _transferNo = '';

        if (q) {
            _transferNo = '&transferNo=' + q;
            _params = _transferNo
        }
        await getData(STOCK_CONFIG.requests.getTransfers.url + `?page=${page}&limit=${rowsPerPage}`, _params).then((response) => {
            if (response.status === true) {
                setData(response.result)
                setLoading(false)
            }
        })
    }
    useEffect(() => {
        getTransferList()
    }, [q, page])
    return (
        <Page>
            <div class="container-fluid">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '20px 0px' }}>
                    <div class="col-lg-5 col-md-12 text-left ">
                        <label class="title-content mb-4">
                            รายการโอนเมล็ดพันธุ์ระหว่างศูนย์
                        </label>
                    </div>
                    <div class="col-lg-3 col-md-12 text-end px-4">
                        <Link to='/stock/stock-transfer/add'>
                            <Button className="ButtomSearch" variant='contained'>+ เพิ่มรายการ</Button>
                        </Link>
                    </div>
                    <div class="col-lg-4 col-md-12">
                        <Box className='backgroundField'>
                            <TextField value={q} onChange={e => setSearchParams({ q: e.target.value })} variant="standard" fullWidth placeholder="ค้นหา เลขที่เอกสาร"
                                InputProps={{
                                    disableUnderline: true,
                                    startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                }}
                            />
                        </Box>
                    </div>
                </div>

                <div class="stockTransfer row">
                    {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :
                        <div class="col-md-12 table-responsive-sm pb-3">
                            <table class="table table-borderless  table-hover ">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th class="text-center">ที่</th>
                                        <th class="text-center">วันที่เอกสาร</th>
                                        <th class="text-center">เลขที่เอกสาร</th>
                                        <th class="text-center">จ่ายออก</th>
                                        <th class="text-center">รับเข้า</th>

                                        <th class="text-center">ผู้ทำรายการ</th>
                                        <th class="text-center">สถานะ</th>
                                        <th class="text-center">ดำเนินการ</th>
                                    </tr>
                                </thead>
                                <tbody class="cp">
                                    {data?.items?.map((x, i) => (
                                        <tr className={id === x?.TransferNo ? 'active' : ''}>
                                            <td style={{ color: 'limegreen', width: '80px', textAlign: 'end' }}>
                                                {x?.ReadStatus === 'N' && (profile?.BranchNo?.BranchNo === x?.ToBranchNo?.BranchNo) && <span> NEW!</span>}
                                            </td>
                                            <td class="text-center">{(page - 1) * rowsPerPage + i + 1}</td>
                                            <td class="text-center">{dayjs(x?.DocumentDate).format('DD/MM/BBBB')}</td>
                                            <td class="text-center">{x?.TransferNo}</td>
                                            <td class="text-center">{x?.FromBranchNo?.BranchName}</td>
                                            <td class="text-center">{x?.ToBranchNo?.BranchName}</td>

                                            <td class="text-center">{x?.ModifiedId}</td>
                                            <td class="text-center">
                                                {x?.Status === 'D' ?
                                                    <span class="status-draft">
                                                        บันทึกร่าง
                                                    </span> : x?.Status === 'W' ?
                                                        <span class="status-wait">
                                                            รออนุมัติ
                                                        </span> : x?.Status === 'Y' ?
                                                            <span class="status-active">
                                                                เสร็จสิ้น
                                                            </span> : x?.Status === 'N' ?
                                                                <span class="status-inactive">
                                                                    ยกเลิก
                                                                </span> : ''}
                                            </td>
                                            <td class="text-center">
                                                <Link to={`/stock/stock-transfer/${x?.TransferNo}`} onClick={() => setSearchParams({ id: x?.TransferNo, page: page, q: q })}>
                                                    <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>เรียกดู</Button>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>}
                    <div class="col-md-12 text-center mt-4">
                        <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={data?.meta?.totalPages} page={+page} onChange={(event, value) => setSearchParams({ page: value, q: q, id: id })} shape="rounded" />
                    </div>


                </div>
            </div>
        </Page >
    )
}
